document.addEventListener('turbolinks:load', function () {
    if ($('.building_valuations.index').length === 0) {
        return false
    }

    $('.upload_building_valuation_btn').on('click', function (e) {
        e.preventDefault();
        $('#file-field').click();
    })

    $('#file-field').on('change', function () {
        $(this).closest("form").submit();
        $('.loading-spinner').show();
        $('body').css({
            pointerEvents: "none"
        })
    })

});